import { Injectable } from '@angular/core';
// import { AppConfiguration } from '@symphony-solo/shared/app-configuration/src';
import { HttpService } from '@symphony-solo/shared/http/src';
import { Observable } from 'rxjs';


@Injectable()
export class VoucherService {
  constructor(
    private httpService: HttpService,
    // private appConfig: AppConfiguration
    ) {}

  public getVouchers(): Observable<any> {
    return this.httpService.makeGet<void>('vouchers',  null, null);
  }

  public setVoucherAutoApply(payload: any): Observable<any> {
    return this.httpService.makePost<any, any>('setvoucherautoapply', payload.voucherAutoApply);
  }
}
